import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;

export const containerCss = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  position: "relative",
};

export const logoLinkCss = {
  root: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
};

export const logoCss = {
  root: {
    justifyContent: "center",
  },
  full: {
    display: "none",
    [mq.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      display: "block",
    },
  },
  mark: {
    flex: "initial",
    [mq.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      display: "none",
    },
  },
};

export const rightButtonCss = {
  root: {
    marginLeft: "auto",
  },
};
